<div id="oie-container">
  <div id="oie-editor">
    <appMargintotal></appMargintotal>
    <appLoadingEditor></appLoadingEditor>
    <appCanvasEditor></appCanvasEditor>
    <appEditorToolbar></appEditorToolbar>
  </div>
</div>
